import {
  Box,
  Button,
  Grid,
  // MenuItem,
  // Select,
  // Typography,
} from "@mui/material";
import React, { useState } from "react";
import Textfield from "../../shared/textfield";
import { button, textFieldOutlineDisabled } from "../../../style2";


export default function DevelopmentalHistory(props) {

  const [disabledField, setDisabledField] = useState(true);
  const [developmentalHistoryList, setDevelopmentalHistoryList] = useState([
    { physicalMilestone: "", ageInMonths: "", additionalInformation: "" },
  ]);
  const [gmfcsLevel, setGmfcsLevel] = useState(0);
  const handleEdit = () => {
    setDisabledField(!disabledField);
    if (!disabledField) {
      // To save changes here
    }
  };

  const handleCancelEdit = () => {
    setDisabledField(true);
  };

  const handlDevelopmentalHistoryAdd = () => {
    setDevelopmentalHistoryList([
      ...developmentalHistoryList,
      { developmentalHistory: "" },
    ]);
  };

  const handleDevelopmentalHistoryDelete = (index) => {
    const list = [...developmentalHistoryList];
    //console.log("removing index:", index);
    list.splice(index, 1);
    setDevelopmentalHistoryList(list);
  };

  const handleGmfcsLevelChange = (event) => {
    setGmfcsLevel(event.target.value);
  };

  const handleDevelopmentalHistoryChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...developmentalHistoryList];
    list[index][name] = value;
    setDevelopmentalHistoryList(list);
  };

  const profile = props.profile;

  function getGmfcsLevelText(level) {
    switch (level) {
      case 1:
        return "Level I";
      case 2:
        return "Level II";
      case 3:
        return "Level III";
      case 4:
        return "Level IV";
      case 5:
        return "Level V";
      case 0:
        return "Not Known";
      default:
        return "";
    }
  }

  return (
    <Box ml={2} mr={2} mb={2}>
      {profile.childDevelopmentList?.map((m, index) => (
        <div key={index}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              {index !== 0 && !disabledField ? <Box m={2} /> : <Box m={1} />}
              {index !== 0 && !disabledField && <Box m={3} />}
              <Textfield title={`Milestone ${index + 1}`} value={m.milestone.title} disabled={disabledField} sx={textFieldOutlineDisabled} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Textfield title="Age In Months" value={`${m.age} Months`} disabled={disabledField} />
            </Grid>
            {m.behaviour !== null && m.behaviour !== "" ?
              <Grid item xs={12}>
                <Textfield title='Additional Information' name='additionalInformation' id='additionalInformation'
                  value={m.behaviour} disabled={disabledField} multiline
                  rows={2} onChange={(e) => handleDevelopmentalHistoryChange(e, index)} />
              </Grid> : null}
          </Grid>
        </div>
      ))}
      <Box m={2} />
      {!disabledField && (
        <>
          <Grid container alignItems='center' justifyContent='flex-start'>
            <Button type='submit' sx={button} onClick={handlDevelopmentalHistoryAdd}>Add</Button>
          </Grid>
          <Box m={2} />
        </>
      )}
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Textfield title="GMFCS Level" value={getGmfcsLevelText(profile.user?.gmfcLevel)} disabled={disabledField} />
          {/* <Typography component="div" sx={textFieldTitle}>
            GMFCS Level
          </Typography>
          <Select value={profile.user?.gmfcLevel} onChange={handleGmfcsLevelChange}
            sx={{...(disabledField ? textFieldOutlineDisabled : textFieldOptional), width: "100%", padding: "3px" }} disabled={disabledField}
            disableUnderline>
            <MenuItem value={0}>Not Known</MenuItem>
            <MenuItem value={1}>Level I</MenuItem>
            <MenuItem value={2}>Level II</MenuItem>
            <MenuItem value={3}>Level III</MenuItem>
            <MenuItem value={4}>Level IV</MenuItem>
            <MenuItem value={5}>Level V</MenuItem>
          </Select> */}
        </Grid>
      </Grid>
    </Box>
  );
}
